import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";
import { FormattedMessage } from "react-intl";
import { RotateLoader } from "react-spinners";
import * as DOMPurify from 'dompurify';
import { myGlobals, myUtilities } from "../../Utils";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";

class CustomLoader extends React.Component {
  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(data) => (
          <Modal
          backdrop={!(myGlobals.currentTheme==="trifectaTheme.css")} 
            show={true}
            onHide={() => {
            }}
            centered
          >
            <Modal.Body>
              <Container className="payment-check-container payment-loader">
                <Row>
                  <Col className="payment-check-element check-pay-trifecta">
                    <RotateLoader
                      size={15}
                      sizeUnit={"px"}
                      color={"#000000"}
                      loading={true}
                    />
                  </Col>
                    <div className="loading-gif-trifecta"></div>
                </Row>
                <Row>
                  <Col className="payment-check-element">
                  {myUtilities.accountSpecificLanguage(
                    this.props.messageID,
                    this.props.defaultMessage
                  )}
                  </Col>
                </Row>
              </Container>
            </Modal.Body>
          </Modal>
        )}
      </Subscribe>
    );
  }
}

export default CustomLoader;
